import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import moneyImage from './../../images/money.png'
import './Payment.css'
import toast from 'react-hot-toast';
import { updatePayment } from '../../service/customerService';
import PaymentCard from './PaymentCard';



const PaymentModal = ({ showModal, handleClose, customer, admin, setNewPayment }) => {

    const [payment, setPayment] = useState([]);
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        if (!showModal && (payment)) {
            setPayment([]);
        }
        else if (showModal) {
            setPayment(customer.payment || [])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showModal])

    const addPaymentCard = () => {
        let flag = true;
        payment.forEach(item => {
            if (!item.dateTimeStamp || !item.type || !item.price) {
                flag = false;
            }
        })
        if (!flag) {
            return toast.error('ابتدا اطلاعات دریافتی های قبل را تکمیل کنید!')
        }
        else {
            let currentPayments = [...payment];
            currentPayments.push({
                type: null,
                dateTimeStamp: false,
                price: '',
                done: false
            })
            setPayment(currentPayments)
        }
    }

    const storPaymentHandler = async (event) => {
        event.preventDefault();
        try {
            let flag = true;
            payment.forEach(item => {
                if (!item.dateTimeStamp || !item.type || !item.price) {
                    flag = false;
                }
            })
            if (!flag) {
                return toast.error('مقادیر دریافتی تکمیل نشده است')
            }
            const params = {
                companyName: customer.companyName,
                payment: payment,
            }
            setIsLoading(true);
            const { status } = await updatePayment(params);
            if (status === 201) {
                setNewPayment(customer.companyName, payment)
                toast.success('عملیات با موفقیت انجام شد')
                handleClose();
            }

        } catch (err) {
            if (err.response && err.response.status === 404) {
                toast.error('کاربر یافت نشد')

            }
            else {
                toast.error('خطایی رخ داده است')
            }
        }
        setIsLoading(false)
    };



    return (
        <Modal
            show={showModal}
            onHide={handleClose}
            aria-labelledby="example223-modal-sizes-title-sm"
            backdrop="static"
            className='payment-modal-layer'
        >
            <Modal.Header>
                <Modal.Title id="license23-modal-sizes-title-sm" className='rtl d-flex align-items-center ml-auto'>
                    <img src={moneyImage} alt="" style={{ width: "40px", marginLeft: '10px' }} />
                    دریافتی ها از مجموعه
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='rtl'>
                {
                    (customer && payment.length) ?
                        payment.map((item, index) =>
                            <PaymentCard
                                key={index}
                                index={index}
                                item={item}
                                setPayment={setPayment}
                            />
                        )
                        :
                        null
                }
                <button onClick={addPaymentCard} className='btn btn-warning btn-sm d-flex align-items-center'>
                    <i className='fa fa-plus mr-2'></i>
                    دریافتی جدید
                </button>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary w-25" onClick={handleClose} disabled={isLoading}>
                    لغو
                </Button>
                <Button variant="success w-25" disabled={!payment || isLoading} onClick={storPaymentHandler}>
                    ذخیره
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default PaymentModal;